export default __webpack_public_path__ + "static/media/gist01.74967615.jpg";